import { css } from '@emotion/css'
import { spacing, shorthandHelper } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    flexDirection: 'column',
    padding: spacing.medium,
  }),

  paragraph: css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  }),

  heading: css({
    margin: shorthandHelper([spacing.default, 0]),
  }),

  list: css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '& > * + *': {
      marginTop: spacing.extraSmall,
    },
  }),
}

export default styles
